
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 99.04 99.04"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Layer 2"}},[_c('path',{attrs:{"d":"M98 85.13L70.29 57.45a3.61 3.61 0 00-3.83-.83 36.33 36.33 0 10-9.84 9.84 3.61 3.61 0 00.83 3.83L85.13 98a3.63 3.63 0 005.14 0L98 90.27a3.63 3.63 0 000-5.14zM19.2 53.45a24.22 24.22 0 1134.25 0 24.21 24.21 0 01-34.25 0z","data-name":"Home Page"}})])])
          )
        }
      }
    